import { Container, ContainerContent, Bar, BarFill, BarContent, MarcIndicator, MarcText, BallContainer, Ball, BallColor } from './styles';

/**
 * Componente para a Barra
 * @param {int} valor valor
 * @param {int} Max valor maximo
 * @param {int} Min valor minimo
 * @param {Object} Alarms alarmes correspondentes
 * @param {boolean} ShowMax indica caso deva exibir o valor maximo
 * @returns {ReactComponentElement} 
 */
const CardBar = ({valor, Max, Min, Alarms, ShowMax, active}) => {

    // Função para buscar o nivel de alerta
    const getAlarm = (valor, l, ll, h, hh) => {
        if(ll != null && (hh === null || hh === undefined) && ll === l && ll !== 0){
            return '#00375E'
        }
        if(hh != null && (ll === null || ll === undefined) && hh === h && hh !== 0){
            return '#00375E'
        }
        if(hh === h && ll === l && hh === ll){
            return '#00375E'
        }
        if(ll != null && ll !== 0){
            if (parseFloat(valor) <= parseFloat(ll)){
                return '#FF3939';
            }
        }
        if(hh != null && hh !== 0){
            if (parseFloat(valor) >= parseFloat(hh)){
                return '#FF3939';
            }
        }
        if(l != null && l !== 0){
            if (parseFloat(valor) <= parseFloat(l)){
                return '#EABC1A';
            }
        }
        if(h != null && h !== 0){
            if (parseFloat(valor) >= parseFloat(h)){
                return '#EABC1A';
            }
        }
        return '#3C9';
    }

    let altura = ((valor-Min)/Max-Min)*100 > 100 ? 100 : ((valor-Min)/Max-Min)*100;
    altura = altura < 0 ? 0 : altura
    let alturaAlarmHH = Alarms?.alarmHH ? ((Alarms.alarmHH-Min)/Max-Min)*100 > 100 ? 100 : ((Alarms.alarmHH-Min)/Max-Min)*100 : false;
    alturaAlarmHH = alturaAlarmHH < 0 ? 0 : alturaAlarmHH
    let alturaAlarmH =  Alarms?.alarmH  ? ((Alarms.alarmH-Min)/Max-Min) *100 > 100 ? 100 : ((Alarms.alarmH-Min) /Max-Min)*100 : false;
    alturaAlarmH = alturaAlarmH < 0 ? 0 : alturaAlarmH
    let alturaAlarmL =  Alarms?.alarmL  ? ((Alarms.alarmL-Min)/Max-Min) *100 > 100 ? 100 : ((Alarms.alarmL-Min) /Max-Min)*100 : false;
    alturaAlarmL = alturaAlarmL < 0 ? 0 : alturaAlarmL
    let alturaAlarmLL = Alarms?.alarmLL ? ((Alarms.alarmLL-Min)/Max-Min)*100 > 100 ? 100 : ((Alarms.alarmLL-Min)/Max-Min)*100 : false;
    alturaAlarmLL = alturaAlarmLL < 0 ? 0 : alturaAlarmLL

    alturaAlarmHH = Alarms?.alarmHH === 0 ? 0 : alturaAlarmHH;
    alturaAlarmH  = Alarms?.alarmH  === 0 ? 0 : alturaAlarmH;
    alturaAlarmL  = Alarms?.alarmL  === 0 ? 0 : alturaAlarmL;
    alturaAlarmLL = Alarms?.alarmLL === 0 ? 0 : alturaAlarmLL;


    let color = getAlarm(valor, Alarms?.alarmL, Alarms?.alarmLL, Alarms?.alarmH, Alarms?.alarmHH)

    return (
        <Container>
            <ContainerContent>
                <Bar $active={active}>
                    <BarFill $active={active}>
                        {ShowMax?
                            <>
                                <MarcIndicator $position={'100'} $color={active ? '#333' : '#333'} $width={'20px'} $left={'5px'}/>
                                <MarcText $position={'100'} $color={active ? '#333' : '#333'} $left={'30px'}>MAX</MarcText>
                            </>
                        :<></>}

                        {alturaAlarmH || alturaAlarmH === 0?
                            <>
                                <MarcIndicator $position={alturaAlarmH} $color={'#EABC1A'} $width={'35px'}/>
                                {/* <MarcBall $position={alturaAlarmH} $color={'#EABC1A'} $left={'32px'}/>
                                <MarcText $position={alturaAlarmH} $color={'#F2F2F2'} $left={'40px'}>H</MarcText> */}
                            </>
                        :<></>}
                        {alturaAlarmHH || alturaAlarmHH === 0?
                            <>
                                <MarcIndicator $position={alturaAlarmHH} $color={'#FF3939'} $width={Math.abs(alturaAlarmHH - alturaAlarmH) > 5 ? '35px' : '55px'}/>
                                {/* <MarcBall $position={alturaAlarmHH} $color={'#FF3939'} $left={Math.abs(alturaAlarmHH - alturaAlarmH) > 5 ? '32px' : '52px'}/>
                                <MarcText $position={alturaAlarmHH} $color={'#F2F2F2'} $left={Math.abs(alturaAlarmHH - alturaAlarmH) > 5 ? '40px' : '60px'}>HH</MarcText> */}
                            </>
                        :<></>}

                        {alturaAlarmL || alturaAlarmL === 0?
                            <>
                                <MarcIndicator $position={alturaAlarmL} $color={'#EABC1A'} $width={'35px'}/>
                                {/* <MarcBall $position={alturaAlarmL} $color={'#EABC1A'} $left={'32px'}/>
                                <MarcText $position={alturaAlarmL} $color={'#F2F2F2'} $left={'40px'}>L</MarcText> */}
                            </>
                        :<></>}

                        {alturaAlarmLL ||  alturaAlarmLL === 0?
                            <>
                                <MarcIndicator $position={alturaAlarmLL} $color={'#FF3939'} $width={Math.abs(alturaAlarmLL - alturaAlarmL) > 5 ? '32px' : '48px'}/>
                                {/* <MarcBall $position={alturaAlarmLL} $color={'#FF3939'} $left={Math.abs(alturaAlarmLL - alturaAlarmL) > 5 ? '32px' : '48px'}/>
                                <MarcText $position={alturaAlarmLL} $color={'#F2F2F2'} $left={Math.abs(alturaAlarmLL - alturaAlarmL) > 5 ? '40px' : '55px'}>LL</MarcText> */}
                            </>
                        :<></>}
                        <BarContent $value={altura} color={color}/>
                        <BallContainer $value={altura}>
                            <Ball $active={active}/>
                            <BallColor color={color}/>
                        </BallContainer>
                    </BarFill>
                </Bar>
            </ContainerContent>
        </Container>
    );
}

export default CardBar;

